import React, { useEffect, useState } from 'react';
import { lang } from '@umu/ukit-lang';
import { IfShow } from 'common/src/components';
import { defaultWhiteOverlayInnerStyle, questionBasicOtherList } from '../../dataFlow';
import { Checkbox, Iconfont, Radio, Tooltip, UmuInput } from '@umu/umu-design';
import { classSet } from '@umu/umu-dom';
interface IOtherOptionInfo {
    isShow: boolean;
    title: string;
    isRequired: string;
}
interface IProps {
    info: IOtherOptionInfo;
    onChange: (info: IOtherOptionInfo) => void;
}

const tips = (
    <div className="question-radio-tooltip">
        <p className="label-desc">-{lang('学员勾选“其他”后可以输入文字。')}</p>
        <p className="label-desc">-{lang('讲师可以使用“其他”选项统计意见、收集备选答案。')}</p>
    </div>
);
const OtherOption = (props: IProps) => {
    const { info, onChange } = props;
    const [isShowDetail, setIsShowDetail] = useState(info.isShow);
    useEffect(() => {
        if (info.isShow !== isShowDetail) {
            setIsShowDetail(false);
        }
    }, [info.isShow]);
    return (
        <div className="external-info option-border">
            <div
                className={classSet({
                    'external-info-heard': true,
                    'active': isShowDetail,
                })}
            >
                <div className="template-question-tooltip">
                    <Checkbox
                        checked={info.isShow}
                        onChange={(e) =>
                            onChange({
                                ...info,
                                isShow: e.target.checked,
                            })
                        }
                    >
                        {lang('添加选项“其他”')}
                    </Checkbox>
                    <Tooltip
                        title={tips}
                        placement="bottom"
                        hideArrow
                        overlayInnerStyle={defaultWhiteOverlayInnerStyle}
                    >
                        <Iconfont type="tips" className="tooltip-icon-tips" />
                    </Tooltip>
                </div>
                <IfShow show={info.isShow}>
                    <Iconfont
                        type="DropDown"
                        className={classSet({
                            'option-drop-down-icon option-drop-grey': true,
                            'active': isShowDetail,
                        })}
                        onClick={() => setIsShowDetail(!isShowDetail)}
                    />
                </IfShow>
            </div>
            <IfShow show={isShowDetail}>
                <div className="external-info-rows-column">
                    <div className="external-info-split is-require">{lang('选项名称')}</div>
                    <UmuInput
                        value={info.title}
                        onChange={({ value }) =>
                            onChange({
                                ...info,
                                title: value,
                            })
                        }
                    />
                    <div className="external-info-split">{lang('学员选择“其他”后')}</div>
                    <Radio
                        list={questionBasicOtherList}
                        onChange={(value) =>
                            onChange({
                                ...info,
                                isRequired: value,
                            })
                        }
                        active={info.isRequired}
                    />
                </div>
            </IfShow>
        </div>
    );
};
export { IOtherOptionInfo, OtherOption };
